<template>
  <div class="d-flex p-5" id="wrapper">
    <div class="container">
      <div class="row mt-4">
        <div class="col-md-8 offset-md-2">
          <div class="card-detail-info card-login">
            <div
              class="img-container"
              style="background-position: bottom left; background-size: cover"
            >
              <!-- <img
                alt=""
                src="/img/logo-white.svg"
                style="opacity:1;width: 100%;height: 35%; object-fit: contain; object-position: center;padding:0 15%"
              /> -->
            </div>
            <div class="info-container p-5">
              <div class="info-body">
                <h3 class="card-login-title">Login to Your Account</h3>

                <form action="" method="post" enctype="multipart/form-data">
                  <!-- {{ csrfField() }} -->
                  <!-- <b-form-select
                    v-model="role"
                    :options="roles"
                    class="mb-3"
                    value-field="value"
                    text-field="label"
                    disabled-field="notEnabled"
                  ></b-form-select> -->
                  <!-- <div class="form-group " v-show="false">
                    <vSelect
                      v-model="role"
                      :options="roles"
                      :searchable="true"
                      :placeholder="'Pilih Role'"
                      :reduce="role => role.value"
                    >
                    </vSelect>
                  </div> -->
                  <hr v-show="false" />
                  <div class="form-group">
                    <label for="exampleInputEmail1">Email address</label>
                    <input
                      type="text"
                      class="form-control"
                      name="username_or_email"
                      aria-describedby="emailHelp"
                      placeholder="Enter your email here"
                      v-model="email"
                      v-on:keyup.enter="() => login()"
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputPassword1">Password</label>
                    <input
                      type="password"
                      class="form-control"
                      name="password"
                      placeholder="Enter your password here"
                      v-model="password"
                      v-on:keyup.enter="() => login()"
                    />
                    <!-- @if(hasErrorFor('password')) -->
                    <h6 v-if="errors && errors.length" class="text-danger mt-2">
                      <!-- {{ getErrorFor('password') }} -->
                      <div
                        v-for="error in errors"
                        v-bind:key="error + Math.random(1024)"
                      >
                        {{ error }}
                      </div>
                    </h6>
                    <!-- @endif -->
                  </div>
                  <!-- <div class="align-left-right">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        name="remember"
                        id="remember"
                      />
                      <label class="custom-control-label" for="remember"
                        >Keep Logged In</label
                      >
                    </div>

                    <router-link to="/forgot-password">
                      Forgot Password?
                    </router-link>
                  </div> -->
                  <div class="row">
                    <div class="col-md-12">
                      <a
                        class="
                          btn btn-block btn-primary
                          my-3
                          btn-primary-gradient
                        "
                        @click="login"
                      >
                        LOGIN
                      </a>
                    </div>
                  </div>

                  <!-- <div class="align-left-right">

                                    <p class="m-0">Do not have an account yet?</p>

                                    <a href="/#/signup/register-role" class="text-secondary">
                                        Register Here
                                    </a>
                                </div> -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ChatWidget />
  </div>
</template>

<script>
// @ is an alias to /src
// import { HTTP,roles } from "@/config.js";
import ChatWidget from "@/components/ChatWidget";
export default {
  name: "Login",
  data: () => {
    return { fromUrl: "", plainUrl: "", password: "", email: "", errors: [] };
  },
  components: { ChatWidget },
  methods: {
    login: async function() {
      this.errors = [];
      if (this.email && this.password) {
        try {
          let result = await this.$store.state.HTTP.post(
            "auth/login",
            `email=${this.email}&password=${this.password}`
          );
          //console.log(result);
          if (result.status == 200) {
            // localStorage.setItem("token", result.data.token);
            // localStorage.setItem("userId",result.data.user.id);
            // localStorage.setItem("email",result.data.user.email);
            // localStorage.setItem("role",result.data.user.role);
            // localStorage.setItem("name",result.data.user.name);
            //console.log(localStorage.getItem('role'));

            /* */
            ////console.log(result.data);
            let { token } = result.data;
            let { email, role, name, id_dokter, id_petugas } = result.data.user;
            let userId = result.data.user.id;
            //console.log({credential:{token,user:{id:userId,name,email,email_verified_at:null,role,created_at:null,updated_at:null}},token,user:{id:userId,name,email,email_verified_at:null,role,created_at:null,updated_at:null}});
            this.$store.dispatch("login", {
              token,
              email,
              role,
              name,
              userId,
              id_dokter,
              id_petugas,
            });
            // result = await this.$store.state.HTTP_SIAKUN.post("cara-pertama-login-simrs",{credential:{token,user:{id:userId,name,email,email_verified_at:null,role,created_at:null,updated_at:null}},token,user:{id:userId,name,email,email_verified_at:null,role,created_at:null,updated_at:null}});
            result = await this.$store.state.HTTP_SIAKUN.post(
              "cara-pertama-login-simrs",
              {
                token,
                user: {
                  id: userId,
                  name,
                  email,
                  email_verified_at: null,
                  role,
                  created_at: null,
                  updated_at: null,
                },
              }
            );
            // Pengecekan login HRIS dinonaktifkan sementara (sering gagal/timeout dan bikin login nyangkut)
            // let resultHris = await this.$store.state.HTTP_HRIS.post(
            //   "auth/silent-login",
            //   { token, user: { id: userId, name, email, role } }
            // );
            if (result.status == "200") {
              //console.log('success');
              this.$router.push("/");
            } else {
              //console.log(result);
            }
            /**/
            /*
            //console.log(result.status);
            let { token } = result.data;
            let {email,role,name} = result.data.user;
            let userId = result.data.user.id
            this.$store.dispatch('login',{token,email,role,name,userId});
            this.$router.push('/');*/
          } else {
            //console.log(result);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push("Email tidak terdaftar atau password Anda salah");
        }
      } else {
        this.errors.push("Anda belum memasukkan Email dan password");
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {},
};
</script>
